// extracted by mini-css-extract-plugin
module.exports = {"badge":"Title_badge__EMmzg","badgeIcon":"Title_badgeIcon__dh8Kk"};